import LayoutHorizontalSidenav from '@/layout/LayoutHorizontalSidenav'

export default [{
  path: '/messages',
  component: LayoutHorizontalSidenav,
  meta: { requiresAuth: true },
  children: [
    {
      path: '',
      component: () => import('@/components/messages/Messages'),
      name: 'Messages',
      props: true,
      meta: {
        keepAlive: true
      }
    },
    {
      path: 'show/:id',
      component: () => import('@/components/messages/Messages'),
      name: 'Show',
      props: true,
      meta: {
        keepAlive: true
      }
    }
  ]
}]
